import { useNavigate, useLocation } from 'react-router-dom'
import { createSessionViewModel, createWebPlatformServices } from '@restaurant/viewmodels'

/**
 * Web-specific SessionViewModel adapter
 * Uses React Router for navigation and web platform services
 */
export const useSessionViewModel = () => {
  const navigate = useNavigate()
  const location = useLocation()
  
  // Create web platform services
  const platformServices = createWebPlatformServices(navigate, location)
  
  // Create and return the platform-agnostic SessionViewModel
  const SessionViewModelHook = createSessionViewModel(platformServices)
  return SessionViewModelHook()
}

// Re-export types for convenience
export type { 
  SessionViewModel, 
  SessionViewModelState, 
  SessionViewModelActions 
} from '@restaurant/viewmodels'